export default "__VITE_ASSET__BGfzQiWe__"